<div class="tooltip"
     [ngClass]="{
        'tooltip--warning': type === 'warning'
     }"
     (mouseenter)="onMouseEnter()"
     tabindex="0"
     role="tooltip"
     aria-live="polite">
    <app-svg-icon iconName="error"></app-svg-icon>
</div>

<div #tooltipContent class="tooltip__content" [class.tooltip__content--right]="positionInit().right">
    <div class="content-wrapper kk-scale-upwards" [class.to-right]="positionInit().right">
        <div class="content display-caption kk-content-fade-in">
            <ng-content></ng-content>
        </div>
    </div>
</div>
